export const blockIconsSocialPersonAdd = (
	<span className='material-symbols-outlined'>person_add</span>
);
